/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { Component, Input, OnInit } from '@angular/core';
import { faBarcodeScan } from '@fortawesome/pro-regular-svg-icons';
import {
  ScannerBarcodeRecordData,
  ScannerRecordData,
  ScanState
} from '../../../../../../../../models/record/items/scanner-record.model';
import { CustomDateFormatService } from '../../../../../../../../services/custom-date-format/custom-date-format.service';

@Component({
  selector: 'scanner-record',
  templateUrl: './scanner-record.component.html',
  styleUrls: ['./scanner-record.component.scss'],
  standalone: false
})
export class ScannerRecordComponent implements OnInit {
  @Input() record!: ScannerRecordData;

  faBarcodeScan = faBarcodeScan;

  readonly ScanState = ScanState;

  constructor(private customDateFormatService: CustomDateFormatService) {}

  ngOnInit() {}

  getTooltipForBarcode(barcode: ScannerBarcodeRecordData): string {
    let tooltip = '';

    if (barcode.scanTime) {
      tooltip += this.customDateFormatService.formatDate(barcode.scanTime);
    }
    if (barcode.barcodeType && barcode.barcodeType !== 'manual') {
      const barcodeType = barcode.barcodeType;
      tooltip += '\n';
      tooltip += $localize`:@@barcodeTypeInfo:Type: ${barcodeType}`;
    }

    return tooltip;
  }
}
